import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 30, className = "", once = true }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once, margin: "-60px" }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
        className={className}
    >
        {children}
    </motion.div>
);

export const SectionHeading = ({ eyebrow, title, script, dark = false, align = "center" }) => {
    const alignCls = align === "center" ? "text-center items-center" : "text-left items-start";
    return (
        <div className={`flex flex-col ${alignCls} gap-4`}>
            {eyebrow && (
                <Reveal>
                    <span
                        className={`text-[11px] tracking-[0.45em] uppercase font-medium ${
                            dark ? "text-gold" : "text-gold-soft"
                        }`}
                    >
                        {eyebrow}
                    </span>
                </Reveal>
            )}
            <Reveal delay={0.1}>
                <h2
                    className={`font-serif text-4xl sm:text-5xl leading-tight tracking-wide ${
                        dark ? "text-ivory" : "text-emerald"
                    }`}
                >
                    {title}
                </h2>
            </Reveal>
            {script && (
                <Reveal delay={0.2}>
                    <p className="font-script text-3xl sm:text-4xl text-gold">{script}</p>
                </Reveal>
            )}
        </div>
    );
};
